import widgetsDataService from '../../services/widgetsDataService.js'
const coinInfo = {

    async updateDynamicsData() {
        let data = $('.widget-coin-info').data();
        let widgetData = await widgetsDataService.fetchWidgetDataAsync('getCoinInfoData', data.coinId, data.currency);

        widgetsDataService.updateDataOnPage('.widget-coin-info', widgetData);
    }

}

export default coinInfo